import { Injectable , Inject} from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable , throwError  } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { APIService } from './api.service'
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends APIService{
  currentUser : any ;
  
  valueSource = new BehaviorSubject<any>({});

  constructor(http: HttpClient,router :Router) {
    super(http)
    this.endPoint = "auth"
  }

  getCandidateInfo(){
    return this.http.get(this.url+`/candidate/`+this.user?.api_token,this.httpOptions)
  }

  public set user(v : any) {
  	this.currentUser = v;
  	localStorage.setItem('auth_app_token', JSON.stringify(v));
  	this.valueSource.next(this.currentUser);
  }

  public get user() : any {
  	try{
	  	this.currentUser = JSON.parse(localStorage.getItem('auth_app_token'))
	  	return this.currentUser;
  	}catch(e){
  		return {};
  	}
  }

  public updateMe(){
    this.valueSource.next(this.currentUser);
  }
}
